import { Controller } from '@hotwired/stimulus';
import Axios from '../axios';

export default class extends Controller {
  connect() {
    this.loading = false;
  }

  change(event) {
    if (event.target.value === 'debit') {
      this.element.classList.add('debit-payment')
    } else {
      this.element.classList.remove('debit-payment')
    }
  }

  async validateDiscount() {
    const currentLanguageCode = document.documentElement.lang.split('-')[0];
    const parent = document.querySelector('#promo-code-holder');
    const route = parent.dataset.route;
    const type = parent.dataset.type;
    const itemId = parent.dataset.itemid;
    const debitid = parent.dataset.debitid;
    const amount = document.querySelector('input[name="amount"]');
    const url = `${route}?rest_language=${currentLanguageCode}`;
    const activateAt = document.querySelector('input[name="activate_at"]');
    const appPromoCode = document.querySelector('input[name="applied-promo-code"]');

    const data = {
      promo: parent.querySelector('input[name="promo-code"]').value,
      type: type,
      itemId: itemId,
      debitId: debitid,
      amount: amount ? amount.value : 1,
      activateAt: activateAt ? activateAt.value : null,
      appliedPromoCode: appPromoCode.value,
    };

    const formData = new FormData();

    for (const dataKey in data) {
      formData.append(dataKey, data[dataKey]);
    }

    const promoInput = parent.querySelector('input[name="promo-code"]');
    const appliedPromoCode = parent.querySelector('#applied-promo-code');

    parent.querySelectorAll('.input-error').forEach(err => err.remove());
    parent.querySelectorAll('.general-success').forEach(msg => msg.remove());

    let response = null;

    if (this.loading) {
      return;
    }

    parent.classList.add('loading');

    this.loading = true;

    try {
      response = await Axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } });

      response = response.data.data;

      parent.classList.remove('loading');

      this.loading = false;
    } catch (error) {
      response = error.response.data.data;

      parent.classList.remove('loading');

      this.loading = false;
    }

    if (response && response.success && response.total && response.successMessage) {
      if (response.cashTotal) {
        this.changeTotal(response.total, response.cashTotal);
      } else {
        this.changeTotal(response.total);
      }
      const messageNode = document.createElement('span');
      messageNode.classList.add('general-success');
      messageNode.innerHTML = response.successMessage;
      promoInput.parentNode.parentNode.append(messageNode);
      appliedPromoCode.value = parent.querySelector('input[name="promo-code"]').value.toUpperCase();


      // set discount data attribute for debit date changes to have effect
      if (response.percentage) {
        parent.dataset.discount = response.percentage;
      }
    }

    if (response && response.errors && Object.keys(response.errors).length) {
      const messageNode = document.createElement('span');
      messageNode.classList.add('input-error');
      messageNode.innerHTML = response.errors.promo;
      promoInput.parentNode.parentNode.append(messageNode);
    }

    if (response && response.general_error) {
      const messageNode = document.createElement('span');
      messageNode.classList.add('input-error');
      messageNode.innerHTML = response.general_error;
      promoInput.parentNode.parentNode.append(messageNode);
    }
  }

  changeTotal(total, cashTotal) {
    const amountElement = document.querySelector('#custom-number-input');
    const priceElement = document.querySelector('.cash-input .item-price');
    const debitPriceElement = document.querySelector('.debit-input .item-price');
    const unitPrice = document.querySelector('input[name="full_price"]');

    if (debitPriceElement) {
      debitPriceElement.innerHTML = (total / 100).toFixed(2) + ' €';
    }

    if (priceElement && total && !cashTotal) {
      priceElement.innerHTML = (total / 100).toFixed(2) + ' €';
      if (amountElement) {
        unitPrice.value = total / amountElement.value + ' €';
      } else {
        unitPrice.value = total + ' €';
      }
    }


    if (cashTotal) {
      priceElement.innerHTML = (cashTotal / 100).toFixed(2) + ' €';
    }
  }

  changeAmount() {
    const amountElement = this.element.querySelector('.coupon-amount-input');
    const priceElement = this.element.querySelector('.item-price');

    if (amountElement && priceElement) {
      const price = parseFloat(amountElement.dataset.originalPrice);
      let amount = parseInt(amountElement.value);

      amount = amount > 0 ? amount : 1;
      amount = amount < 99 ? amount : 99;
      priceElement.innerHTML = (Math.round((amount * price) * 100) / 100).toFixed(2) + ' €';
      amountElement.value = amount + '';
    }
  }

  toggleNewClient(event) {
    if (event.currentTarget.querySelector('[name="new_member"]').value === '1') {
      this.element.classList.add('new-client-payment')
    } else {
      this.element.classList.remove('new-client-payment')
    }
  }

  toggleAdditionalProduct(event) {
    const header = this.element.querySelector('.additional-products-title');
    const holder = this.element.querySelector('.additional-products-holder');
    const checked = event.currentTarget.checked;
    const value = event.currentTarget.value;
    const title = event.currentTarget.dataset.title;

    for (const additionalProductCheckbox of this.element.querySelectorAll('input[name="additional_products[]"]')) {
      additionalProductCheckbox.checked = false;
    }

    event.currentTarget.checked = checked;

    holder.innerHTML = '';

    if (checked) {
      const node = document.createElement('li');
      node.classList.add(`additional-item-${value}`);
      node.innerHTML = title;
      holder.appendChild(node);
    }

    if (holder.children.length) {
      header.classList.remove('d-none');
    } else {
      header.classList.add('d-none');
    }
  }
}
